import React, { useState, useEffect } from 'react';
import SitePageBody from '../components/common/SitePageBody';
import { getSitePage } from '../services/api';
import SEO from '../components/SEO';
import FroggySpinner from '../components/common/FroggySpinner';
import { CORE_KEYWORDS } from '../constants/seoKeywords';
import '../styles/policy-page.css';

const ShippingPolicyPage = () => {
  const [content, setContent] = useState(null);
  const [title, setTitle] = useState('Shipping Policy');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        setLoading(true);
        const data = await getSitePage('shipping-policy');
        setContent(data.content_md);
        setTitle(data.title);
        setError(false);
      } catch (err) {
        console.error('Failed to fetch shipping policy content:', err);
        setError(true);
      } finally {
        setLoading(false);
      }
    };

    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="policy-page">
        <div className="policy-page-container" style={{ textAlign: 'center', padding: 'var(--ff-space-5xl)' }}>
          <FroggySpinner size="lg" label="Loading shipping policy" />
        </div>
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="policy-page">
        <div className="policy-page-container">
          <h1 className="policy-page-title">Shipping Policy</h1>
          <p className="policy-page-text">
            This content is temporarily unavailable. Please try again later.
          </p>
        </div>
      </div>
    );
  }

  return (
    <>
      <SEO
        title="Shipping Policy - Live Dart Frog Delivery"
        description="Learn about our shipping policy for live dart frogs and supplies. Live arrival guarantee, overnight shipping options, weather holds, and safe delivery practices."
        canonical="https://feelingfroggy.llc/shipping-policy"
        keywords={CORE_KEYWORDS}
      />
      <div className="policy-page">
        <div className="policy-page-container">
          <h1 className="policy-page-title">{title}</h1>
          <SitePageBody className="policy-page-content" title={title} content={content} />
        </div>
      </div>
    </>
  );
};

export default ShippingPolicyPage;